import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {withTranslation} from "react-i18next";

function Content(props) {
    return <div style={(props.hasOwnProperty('style')) ? props.style : null}
                className={`Content ${props.hasOwnProperty('className') ? props.className : ''}`}>
            {props.children}
           </div>
}

const mapStateToProps = (store) => {
    return {
        breamb: store.breambState,
    };
};

export default connect(mapStateToProps)(withRouter(withTranslation()(Content)));